import React from 'react';
import { Navigate } from 'react-router-dom';
import { auth } from '@/lib/auth';

export const ProtectedAdminRoute = ({ children }) => {
  if (!auth.isLoggedIn()) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};
